export class TipoTransporteModel {
  id: number;
  nome_pt: string;
  nome_en: string;
  nome_es: string;
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd/tipo-transporte.model.ts